var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import { mapActions, mapGetters } from "vuex";
import BasicArcheivesService from '../../api/BasicArcheivesService';
import { Loading } from 'element-ui';
import { codeDictMap } from '../../constant/authCode';
import AddAndEditStore from './component/AddAndEditStore.vue';
import InitStoreDialog from './component/InitStoreDialog.vue';
import Add from '../stockInit/Add.vue';
import StoreSplit from './StoreSplit';
import StoreSplitRule from './StoreSplitRule';
import TableHeaderToolTip from './component/TableHeaderToolTip.vue';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
var StoreArchives = (function (_super) {
    __extends(StoreArchives, _super);
    function StoreArchives() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.organList = [];
        _this.dialogVisible = true;
        return _this;
    }
    StoreArchives.prototype.created = function () {
        var _this = this;
        console.log('this.Root_PageAuth', this.Root_PageAuth);
        console.log('this.openedCodeData', this.openedCodeData);
        this.service = BasicArcheivesService.getInstance();
        this.getOrganList().then(function () {
            _this.getSupplierdepotList();
        });
    };
    StoreArchives.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 211;
        }, 300);
    };
    StoreArchives.prototype.getOrganList = function () {
        var _this = this;
        return this.service.getOrganList().then(function (res) {
            var data = res.data.data;
            console.log(data);
            _this.organList = data || [];
        });
    };
    StoreArchives.prototype.getSupplierdepotList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.pager = pager;
        var params = {};
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getSupplierdepotList(params).then(function (res) {
            var data = res.data.data;
            _this.listData = data || [];
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreArchives.prototype.changeDefaultStore = function (data) {
        var _this = this;
        if (data.is_organ_default == 0) {
            this.$confirm("\u673A\u6784\u7684\u9ED8\u8BA4\u4ED3\u5E93\u4E0D\u5141\u8BB8\u5173\u95ED\n                \u8BF7\u76F4\u63A5\u5C06\u5176\u4ED6\u975E\u9ED8\u8BA4\u4ED3\u5E93\u8BBE\u7F6E\u4E3A\u9ED8\u8BA4\u4ED3\u5E93", '提示', {
                confirmButtonText: '确认',
                center: true,
            });
            data.is_organ_default = 1;
            return;
        }
        this.service.changeDefaultStore({
            depot_id: data.depot_id,
            confirm: 0,
        }).then(function (res) {
            if (res.data.code == 1) {
                _this.$confirm(res.data.msg, '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    center: true,
                }).then(function () {
                    _this.setDefaultStore(data, {
                        confirm: 1
                    });
                }).catch(function () {
                    if (data.is_organ_default == 0) {
                        data.is_organ_default = 1;
                    }
                    else {
                        data.is_organ_default = 0;
                    }
                });
            }
            else {
                _this.$message.success("切换成功");
                _this.getSupplierdepotList(_this.pager);
            }
        }, function (err) {
            _this.$message.error(err.message);
            if (data.is_organ_default == 0) {
                data.is_organ_default = 1;
            }
            else {
                data.is_organ_default = 0;
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
            if (data.is_organ_default == 0) {
                data.is_organ_default = 1;
            }
            else {
                data.is_organ_default = 0;
            }
        });
    };
    StoreArchives.prototype.setDefaultStore = function (data, params) {
        var _this = this;
        this.service.changeDefaultStore({
            depot_id: data.depot_id,
            confirm: params.confirm,
        }).then(function (res) {
            _this.$message.success("切换成功");
            _this.getSupplierdepotList(_this.pager);
        }, function (err) {
            _this.$message.error(err.message);
            if (data.is_organ_default == 0) {
                data.is_organ_default = 1;
            }
            else {
                data.is_organ_default = 0;
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
            if (data.is_organ_default == 0) {
                data.is_organ_default = 1;
            }
            else {
                data.is_organ_default = 0;
            }
        });
    };
    StoreArchives.prototype.changeStoreStatus = function (status) {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择仓库！');
            return;
        }
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426" + (status ? '启用' : '停用') + "\u8BE5\u4ED3\u5E93", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var params_1 = {
                    depot_ids: '',
                    status: status ? 1 : 0
                };
                _this.selectRows.forEach(function (item) {
                    if (!params_1.depot_ids) {
                        params_1.depot_ids = item.depot_id;
                    }
                    else {
                        params_1.depot_ids = params_1.depot_ids + ',' + item.depot_id;
                    }
                });
                _this.service.changeStoreStatus(params_1).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success((status ? '启用' : '停用') + "\u4ED3\u5E93\u6210\u529F");
                        _this.getSupplierdepotList(_this.pager);
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                    loadingInstance_1.close();
                }, function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                });
            }
        }).catch(function () { });
    };
    StoreArchives.prototype.updated = function () {
    };
    StoreArchives.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    StoreArchives.prototype.pageChange = function (pager) {
        this.getSupplierdepotList(pager);
    };
    StoreArchives.prototype.toUpdateInitStore = function (data) {
        var _this = this;
        var init_store_auth = false;
        var store_split_rule_auth = true;
        this.getAuth(codeDictMap.storeInit.code).then(function (auth) {
            console.log('auth===>', auth);
            if (auth) {
                init_store_auth = true;
            }
            if (_this.ediStatus) {
                return;
            }
            var instance = _this.$dialog(InitStoreDialog, {
                data: {
                    init_store_auth: init_store_auth,
                    store_split_rule_auth: store_split_rule_auth,
                }
            }, {
                title: [
                    '仓库添加成功！',
                    'text-align: center;color: #08BD06;border-bottom: 0px;'
                ],
                width: 420,
                height: 270,
            }).instance;
            instance.$on("toInitStore:ok", function (data) {
                console.log('data===>', data);
                _this.getSupplierdepotList();
                _this.getAuth(codeDictMap.storeInit.code).then(function (auth) {
                    console.log('auth', auth);
                    if (auth) {
                        GlobalVue.$emit('addTab', {
                            component: Add,
                            title: '添加期初单',
                            showExist: true,
                            name: 'stockinit_add',
                            cprops: {
                                storeInfo: data
                            }
                        });
                    }
                    else {
                        _this.$message.error("权限不足");
                        return;
                    }
                });
            });
            instance.$on("toStoreSplitRule:ok", function (data) {
                _this.StoreSplitRule();
            });
        });
    };
    StoreArchives.prototype.addStore = function () {
        var _this = this;
        var instance = this.$dialog(AddAndEditStore, {
            data: {
                organList: this.organList,
                ediStatus: this.ediStatus,
                handleStatus: 1,
            }
        }, {
            title: this.ediStatus ? "配送中心信息" : "仓库信息",
            width: 560,
            height: 400
        }).instance;
        instance.$on("addClient:ok", function (data) {
            console.log('data===>', data);
            _this.getSupplierdepotList();
            _this.getAuth(codeDictMap.storeInit.code).then(function (auth) {
                if (_this.openedCodeData.isOpenERP) {
                    _this.toUpdateInitStore(data);
                }
            });
        });
    };
    StoreArchives.prototype.editStore = function (storeEditInfo) {
        var _this = this;
        var instance = this.$dialog(AddAndEditStore, {
            data: {
                storeEditInfo: storeEditInfo,
                organList: this.organList,
                ediStatus: this.ediStatus,
                handleStatus: 2,
            }
        }, {
            title: this.ediStatus ? "配送中心信息" : "仓库信息",
            width: 560,
            height: 400
        }).instance;
        instance.$on("addClient:ok", function () {
            _this.getSupplierdepotList(_this.pager);
        });
    };
    StoreArchives.prototype.splitStore = function () {
        console.log(11111);
        GlobalVue.$emit("addTab", {
            component: StoreSplit,
            title: "配送规则",
            name: "store_list_rule",
            showExist: true,
        });
    };
    StoreArchives.prototype.StoreSplitRule = function () {
        GlobalVue.$emit("addTab", {
            component: StoreSplitRule,
            title: "出库规则",
            name: "store_list_depot_rule",
            showExist: true,
        });
    };
    StoreArchives.prototype.updateInitStore = function (data) {
        var _this = this;
        var isAddTab = true;
        var that = this;
        this.$confirm("\u7EE7\u7EED\u4E0B\u4E00\u6B65\uFF1A\u521D\u59CB\u5316\u5E93\u5B58", '仓库添加成功', {
            customClass: 'confirm storeAddAndEditConfirm',
            showClose: false,
            confirmButtonText: '去设置',
            closeOnClickModal: false,
            center: true,
            showCancelButton: false
        }).then(function (rescof) {
            if (isAddTab) {
                _this.getSupplierdepotList();
                _this.getAuth(codeDictMap.storeInit.code).then(function (auth) {
                    console.log('auth', auth);
                    if (auth) {
                        GlobalVue.$emit('addTab', {
                            component: Add,
                            title: '添加期初单',
                            showExist: false,
                            name: 'stockinit_add',
                            cprops: {
                                storeInfo: data
                            }
                        });
                    }
                    else {
                        _this.$message.error("权限不足");
                        return;
                    }
                });
            }
        }).catch(function () { });
        setTimeout(function () {
            isAddTab = false;
        }, 3500);
    };
    StoreArchives.prototype.toInitStore = function (data) {
        var _this = this;
        this.getSupplierdepotList();
        this.getAuth(codeDictMap.storeInit.code).then(function (auth) {
            console.log('auth', auth);
            if (auth) {
                GlobalVue.$emit('addTab', {
                    component: Add,
                    title: '添加期初单',
                    showExist: false,
                    name: 'stockinit_add',
                    cprops: {
                        storeInfo: data
                    }
                });
            }
            else {
                _this.$message.error("权限不足");
                return;
            }
        });
    };
    StoreArchives = __decorate([
        auth(nameDict["配送中心档案"], true),
        Component({
            components: {
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                "ediStatus": "ediStatus"
            })),
            methods: __assign({}, mapActions(["getAuth"]), { renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "采购数量*采购系数+库存数量",
                            placement: "bottom"
                        }
                    }, '机构默认库');
                } })
        })
    ], StoreArchives);
    return StoreArchives;
}(Vue));
export default StoreArchives;
